
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

const Header = ({ isLoggedIn, setIsLoggedIn, handleLogout, onUpgradeClick }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path) => {
    if (path === '/' || path === '/about') {
      navigate(path);
    } else if (isLoggedIn) {
      navigate(path);
    } else {
      navigate('/signup');
    }
  };

  const isActive = (path) => location.pathname === path;

  const XIcon = () => (
    <svg width="18" height="18" fill="currentColor" viewBox="0 0 1200 1227" aria-hidden="true">
      <path d="M1199.61 21.5H976.6L600.01 537.5 223.41 21.5H.39l464.2 637.5L0 1205.5h223.41l376.6-516.5 376.6 516.5h223.41l-464.2-637.5 464.19-637.5z" />
    </svg>
  );

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'Daily', path: '/daily' },
    { label: 'Metrics', path: '/metrics' },
    { label: 'Definitions', path: '/definition' },
    { label: 'Visualisations', path: '/metric-visualisations' },
    { label: 'Market', path: '/market-context' },
  ];

  return (
    <div className="bg-white/80 backdrop-blur-md border-b border-gray-200/60 shadow-header w-full sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex flex-col items-center gap-3 md:flex-row md:items-center md:justify-between">
          
          {/* Logo + brand */}
          <div className="flex items-center gap-3 flex-shrink-0">
            <img src={logo} alt="Luminoso" className="h-10 w-10 md:h-12 md:w-12 rounded-lg" />
            <span className="text-lg font-bold text-gray-900 tracking-tight hidden sm:inline">
              Luminoso
            </span>
          </div>

          {/* Main nav */}
          <nav className="flex flex-wrap items-center justify-center gap-1">
            {navItems.map(({ label, path }) => (
              <button
                key={path}
                className={`nav-link ${isActive(path) ? 'nav-link-active' : ''}`}
                onClick={() => handleNavigation(path)}
              >
                {label}
              </button>
            ))}
          </nav>

          {/* Auth / CTA / Social */}
          <div className="flex flex-wrap items-center justify-center gap-2 min-w-0">
            {!isLoggedIn && (
              <>
                <button
                  className="nav-link"
                  onClick={() => navigate('/login')}
                >
                  Log In
                </button>
                <button
                  className="btn-primary text-sm"
                  onClick={() => navigate('/signup')}
                >
                  Create Free Account
                </button>
              </>
            )}

            {isLoggedIn && (
              <>
                <button
                  className="btn-primary text-sm"
                  onClick={() => navigate('/subscribe')}
                >
                  Upgrade to Pro
                </button>
                <button
                  className="nav-link"
                  onClick={handleLogout}
                >
                  Log Out
                </button>
              </>
            )}

            <a
              href="https://twitter.com/LuminosoApp"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center text-gray-400 hover:text-gray-700 transition-colors duration-150 ml-1"
              aria-label="Follow us on X"
            >
              <XIcon />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;

